import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AboutLeadership, John  } from '../../assets/img';
// import { NavigationBar } from '../../components';
// import { Footer } from '../../components/footer';
import { Link } from 'react-router-dom';
import { profileBreadcrumb } from '../../components/main/products';
import { Screen } from '../../styles'


// const Navigation = NavigationBar.Navigation;
const JohnOkonkow = () => {
  const [mobile, setMobile] = useState(false);
  const responsive = () => {
    window.innerWidth <= 900 ? setMobile(true): setMobile(false)
  }
  useEffect(() => {
    //Scroll to top on page load
    window.scrollTo(0, 0);

    responsive()
    window.addEventListener('resize', () => responsive())

    return () => {
      window.removeEventListener('resize', () => responsive())
    }
  }, []);
  return (
    <Box>
      {/* navigation */}
      {/* <Navigation /> */}
      {/* End of Navigation */}

      {/* Hero Section */}
      <Section className='hero'></Section>
      {/* End of hero section */}
      <BreadCrumb>
        {profileBreadcrumb.map(({ name, path }) => (
          <>
            <Links to={path}>{name}</Links> <span>/</span>
          </>
        ))}
      </BreadCrumb>

      {/* Profile section */}
      <Section>
        <Container>
          {
            mobile ? (
              <FlexBox>
                <div>
                <Header>John Okonkwo</Header>
              <Title>Executive Director, Finance, Risk & Operations</Title>
                </div>
                <Image src={John} alt='Professional Portrait of John Okonkwo.' 
             aria-description='A professional headshot of John Okonkwo, the Executive Director of Finance, Risk, and Operations at Abbey Mortgage Bank. He is dressed in a sharp blue suit, crisp white shirt, and a bold red tie, conveying confidence and competence. The image is suitable for corporate websites, press releases, annual reports, and financial publications seeking a visual representation of leadership, expertise, and stability within the banking and finance sector. The soft lighting and neutral background allow for easy integration into various layouts and designs.'/>
            
                <Paragraph>
                <p>
               John Okonkwo is an accomplished and experienced Finance Professional, 
               Auditor, Risk Management Practitioner, Board and Corporate Governance Advisor, 
               Compliance Risk Management and Sustainability Services Professional, 
               Operations Personnel and Training Facilitator.
              </p>
              <p>
            John has over 20 years of experience leading strategic initiatives across 
            industries with a particular focus on financial services. He is KPMG-trained, 
            a Fellow of the Institute of Chartered Accountants of Nigeria (ICAN), 
            an Associate of the Chartered Institute of Taxation of Nigeria (CITN) and an 
            Alumnus of the Advanced Management Programme (AMP) of the Lagos Business School (LBS).
            </p>
            <p>
            John worked as an external auditor to banks, discount houses and other financial 
            services institutions, board and corporate governance adviser to banks and other financial services 
            institutions, risk management and compliance adviser to banks and other financial services institutions, 
            a senior staff of United Bank for Africa Plc (as technical adviser to the Group Managing Director and Chief 
            Audit Executive Designate) and adviser to the Chairman of United Bank for Africa Plc.
            </p>
            <p>
              John’s professional specialties include Risk Management and Compliance, Operations, Financial Control, 
              Corporate Governance, Auditing and General Administration.
            </p>
                </Paragraph>
              </FlexBox>
            ): (
              <> 
          <FlexBox>
            <Image src={John}
             alt='Professional Portrait of John Okonkwo.' 
             aria-description='A professional headshot of John Okonkwo, the Executive Director of Finance, Risk, and Operations at Abbey Mortgage Bank. He is dressed in a sharp blue suit, crisp white shirt, and a bold red tie, conveying confidence and competence. The image is suitable for corporate websites, press releases, annual reports, and financial publications seeking a visual representation of leadership, expertise, and stability within the banking and finance sector. The soft lighting and neutral background allow for easy integration into various layouts and designs.'/>
            <Content>
              <Header>John Okonkwo</Header>
              <Title>Executive Director, Finance, Risk & Operations</Title>
              <p>
              John Okonkwo is an accomplished and experienced Finance Professional, 
               Auditor, Risk Management Practitioner, Board and Corporate Governance Advisor, 
               Compliance Risk Management and Sustainability Services Professional, 
               Operations Personnel and Training Facilitator.
                       
              <br></br>
              <br></br>
              

            John has over 20 years of experience leading strategic initiatives across 
            industries with a particular focus on financial services. He is KPMG-trained, 
            a Fellow of the Institute of Chartered Accountants of Nigeria (ICAN), 
            an Associate of the Chartered Institute of Taxation of Nigeria (CITN) and an 
            Alumnus of the Advanced Management Programme (AMP) of the Lagos Business School (LBS).
             <br></br>
              </p>
            </Content>
          </FlexBox>
          <Content className='more'>
            {/* <p>
            John has over 20 years of experience leading strategic initiatives across 
            industries with a particular focus on financial services. He is KPMG-trained, 
            a Fellow of the Institute of Chartered Accountants of Nigeria (ICAN), 
            an Associate of the Chartered Institute of Taxation of Nigeria (CITN) and an 
            Alumnus of the Advanced Management Programme (AMP) of the Lagos Business School (LBS).
            </p> */}
            <p>
             John worked as an external auditor to banks, discount houses and other financial 
            services institutions, board and corporate governance adviser to banks and other financial services 
            institutions, risk management and compliance adviser to banks and other financial services institutions, 
            a senior staff of United Bank for Africa Plc (as technical adviser to the Group Managing Director and Chief 
            Audit Executive Designate) and adviser to the Chairman of United Bank for Africa Plc.
            </p>
            <p>
              John’s professional specialties include Risk Management and Compliance, Operations, Financial Control, 
              Corporate Governance, Auditing and General Administration.
            </p>
          </Content>
              </>
            )
          }
        </Container>
      </Section>
      {/* End of profile section */}
      {/* Footer */}
      {/* <Footer /> */}
      {/* End of Footer */}
    </Box>
  );
};

const Box = styled.div`
  width: 100%;
  min-height: 100vh;
`;
const Section = styled.div`
  width: 100%;
  &.hero {
    min-height: 60vh;
    background-image: url(${AboutLeadership});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-top: 80px;
    ${Screen.mediumpc`
    min-height: 40vh!important;
    `}
    ${Screen.smallpc`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    `}
     ${Screen.tablet`
    min-height: 40vh!important;
    margin-top: 5rem!important;
    `}
     ${Screen.surfaceDuo`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    `}
    ${Screen.mediumPhone`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    `}
    ${Screen.phone`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    `}
    ${Screen.smallPhone`
    min-height: 30vh;
    margin-top: 5rem!important;
    `}
  }
`;
const Container = styled.div`
  width: 70%;
  margin: 5rem auto;
  ${Screen.miniLargeScreen`
  width: 80%;
  `}
  ${Screen.pad`
  width: 80%;
  `}
  ${Screen.mediumpc`
  width: 80%;
  `}
  ${Screen.smallpc`
  width: 70%;
  margin-bottom: 3rem
  `}
   ${Screen.tablet`
  width: 80%;
  margin-bottom: 3rem
  `}
  ${Screen.mediumPhone`
  width: 80%;
  margin-bottom: 3rem
  `}
  ${Screen.phone`
  width: 80%
  `}
  ${Screen.smallPhone`
  width: 80%
  `}
  ${Screen.galaxyFold`
  width: 90%
  `}
`;
const FlexBox = styled.div`
  display: flex;
  ${Screen.smallpc`
  flex-direction: column;
  `}
`;
const Image = styled.img`
width: 30%;
height: 380px;

${Screen.miniLargeScreen`
width: 300px;
height: 380px;
`}
${Screen.pad`
width: 300px;
height: 380px;
`}
${Screen.mediumpc`
width: 300px;
height: 380px;
`}
${Screen.smallpc`
width: 250px;
height: 280px;
margin: 2rem auto;
`}
${Screen.mediumPhone`
width: 70%;
height: 280px;
margin: 1rem auto;
`}
${Screen.phone`
width: 80%;
height: 250px;
margin: 1rem auto;
`}
${Screen.smallPhone`
width: 90%;
height: 250px;
margin: 1rem auto;
`}
${Screen.galaxyFold`
width: 80%;
height: 250px;
margin: 1rem auto;
`}
`;
const Content = styled.div`
  width: 50%;
  margin-left: 3rem;
  padding-top: 1.5rem;

  ${Screen.miniLargeScreen`
  padding-top: 0!important;
  `}

  p {
    word-spacing: 0.1rem;
    padding-top: 1rem;
  }

  &.more {
    width: 90%;
    margin-left: 0;
  }
`;
const Header = styled.h2`
  padding-bottom: 0.5rem;
  ${Screen.smallpc`
  text-align: center;
  font-size: 22px;
  `}
  ${Screen.mediumPhone`
  text-align: center;
  font-size: 22px;
  `}
  ${Screen.phone`
  text-align: center;
  font-size: 20px;
  `}
  ${Screen.smallPhone`
  text-align: center;
  font-size: 18px;
  `}
`;
const Title = styled.article`
${Screen.smallpc`
font-size: 12px;
text-align: center;
`}
${Screen.mediumPhone`
font-size: 12px;
text-align: center;
`}
${Screen.phone`
font-size: 12px;
text-align: center;
`}
${Screen.smallPhone`
font-size: 12px;
text-align: center;
`}
`;
const BreadCrumb = styled.div`
  width: 100%;
  height: 3rem;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  padding-left: 5rem;
  /* position: fixed; */

  span {
    font-weight: bold;
    padding-right: 0.5rem;
  }

  ${Screen.tablet`
  display: none;
  `}
`;
const Links = styled(Link)`
  color: #002668;
  text-decoration: none;
  font-weight: bold;
  padding-right: 0.3rem;
`;
const Paragraph = styled.div`
p {
  ${Screen.mediumPhone`
  font-size: 14px;
  padding-bottom: 1rem;
  `}
  ${Screen.phone`
  font-size: 14px;
  padding-bottom: 1rem;
  `}
  ${Screen.smallPhone`
  font-size: 14px;
  padding-bottom: 1rem;
  `}
   ${Screen.galaxyFold`
  font-size: 12px;
  padding-bottom: 1rem;
  `}
}
`;
export default JohnOkonkow;
